var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdduser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_963_2287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 2.68271C6.60215 2.68271 5.46519 3.81965 5.46519 5.21751C5.46519 6.61536 6.60212 7.7523 7.99998 7.7523C9.39784 7.7523 10.5348 6.61533 10.5348 5.21751C10.5348 3.81968 9.39784 2.68271 7.99998 2.68271ZM7.99998 6.85662C7.09661 6.85662 6.36086 6.12088 6.36086 5.21751C6.36086 4.31414 7.09661 3.57839 7.99998 3.57839C8.90335 3.57839 9.6391 4.31414 9.6391 5.21751C9.6391 6.12088 8.90338 6.85662 7.99998 6.85662Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8696 5.46519C11.8558 5.46519 11.0305 6.29048 11.0305 7.3043C11.0305 8.31813 11.8558 9.14342 12.8696 9.14342C13.8834 9.14342 14.7087 8.31813 14.7087 7.3043C14.7087 6.29048 13.8834 5.46519 12.8696 5.46519ZM12.8696 8.24778C12.3495 8.24778 11.9261 7.82439 11.9261 7.3043C11.9261 6.78422 12.3495 6.36083 12.8696 6.36083C13.3897 6.36083 13.8131 6.78422 13.8131 7.3043C13.8131 7.82439 13.3897 8.24778 12.8696 8.24778Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17979 5.46519C2.16522 5.46519 1.34067 6.2905 1.34067 7.3043C1.34067 8.31813 2.16597 9.14342 3.17979 9.14342C4.19362 9.14342 5.01891 8.31813 5.01891 7.3043C5.01891 6.2905 4.19433 5.46519 3.17979 5.46519ZM3.17979 8.24778C2.65971 8.24778 2.23631 7.82439 2.23631 7.3043C2.23631 6.78422 2.65971 6.36083 3.17979 6.36083C3.69988 6.36083 4.12327 6.78422 4.12327 7.3043C4.12327 7.82439 3.69985 8.24778 3.17979 8.24778Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 8.2479C5.45156 8.2479 3.37827 10.3212 3.37827 12.8696C3.37827 13.1169 3.57888 13.3175 3.82611 13.3175C4.07334 13.3175 4.27394 13.1169 4.27394 12.8696C4.27394 10.815 5.94533 9.14357 8.00002 9.14357C10.0547 9.14357 11.7261 10.815 11.7261 12.8696C11.7261 13.1169 11.9267 13.3175 12.1739 13.3175C12.4212 13.3175 12.6218 13.1169 12.6218 12.8696C12.6218 10.3212 10.5485 8.2479 8.00002 8.2479Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1962 10.1057L11.1962 10.1057L11.1957 10.1059C10.9857 10.2346 10.9173 10.5093 11.0456 10.7209L11.0456 10.7209L11.0459 10.7215C11.1753 10.9321 11.4492 10.9997 11.6608 10.8715L11.6609 10.8714C12.0242 10.6508 12.4417 10.5347 12.8695 10.5347C14.1569 10.5347 15.2043 11.582 15.2043 12.8694C15.2043 13.1167 15.4049 13.3173 15.6522 13.3173C15.8994 13.3173 16.1 13.1167 16.1 12.8694C16.1 11.0883 14.6507 9.63901 12.8695 9.63901C12.2788 9.63901 11.7002 9.80052 11.1962 10.1057Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33828 10.8707C4.54911 10.999 4.82477 10.9315 4.95355 10.7205C5.0828 10.5086 5.01418 10.2337 4.8034 10.1051L4.80306 10.1049C4.29977 9.80051 3.7212 9.63901 3.13043 9.63901C1.34929 9.63901 -0.1 11.0883 -0.1 12.8694C-0.1 13.1167 0.100608 13.3173 0.347837 13.3173C0.595065 13.3173 0.795673 13.1167 0.795673 12.8694C0.795642 11.582 1.84306 10.5347 3.13043 10.5347C3.55819 10.5347 3.97564 10.6507 4.33828 10.8707ZM4.33828 10.8707L4.39026 10.7853L4.33841 10.8708C4.33836 10.8707 4.33832 10.8707 4.33828 10.8707Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_2287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdduser);
export default __webpack_public_path__ + "static/media/adduser.c5dfe0a6d2b1cfd86d246ccee7d2a814.svg";
export { ForwardRef as ReactComponent };